import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RouterModule, Routes} from "@angular/router";
import {LoginPageComponent} from "./login-page/login-page.component";
import {LoginPageGuard} from "./login-page-guard/login-page.guard";
import {AuthGuard} from "./auth-guard/auth.guard";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthInterceptor} from "./auth-interceptor/auth.interceptor";
import {LoginFormComponent} from "./login-form/login-form.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { EncodeJsonInterceptor } from "../interceptor/encode-json.interceptor";
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LogoutRedirectComponent } from "./logout-redirect.component";

const loginRoutes: Routes = [
  {
    path: "login",
    component: LoginPageComponent,
    canActivate: [LoginPageGuard],
  },
  {
    path: "logoutRedirect",
    component: LogoutRedirectComponent,
    canActivate: [LoginPageGuard],
  },

];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(loginRoutes, {}),
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule,
    MatProgressSpinnerModule,
    LogoutRedirectComponent,
  ],
  declarations: [
    LoginPageComponent,
    LoginFormComponent,
    LoginDialogComponent,
  ],
  exports: [
    LoginDialogComponent,
  ],
  providers: [
    AuthGuard,
    LoginPageGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: TRANSLOCO_SCOPE, useValue: 'login' },
  ]
})
export class LoginModule { }
